<div class="overflow-container">
  <textarea
    #textInput
    type="text"
    placeholder="Type number here"
    (blur)="onPropertyUpdated($event.target.value.trim())"
    [(ngModel)]="inputValue"
  ></textarea>
</div>

<p class="error-text" *ngIf="!isNumber(inputValue)" i18n>Please input a number</p>
